/* NAILZ: upsell del carrito
   Botón "Agregar" de snippets/nailz-upsell-carrito.liquid: agrega el diseño y vuelve a dibujar
   el carrito lateral con la respuesta (mismo mecanismo que el formulario de producto del tema). */
(function () {
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-nz-upsell-add]');
    if (!button) return;
    event.preventDefault();
    if (button.getAttribute('aria-disabled') === 'true') return;

    button.setAttribute('aria-disabled', 'true');
    button.classList.add('is-loading');

    var drawer = document.querySelector('cart-drawer');
    var sections =
      drawer && typeof drawer.getSectionsToRender === 'function'
        ? drawer.getSectionsToRender().map(function (section) {
            return section.id;
          })
        : [];
    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';

    fetch(addUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(button.dataset.variantId), quantity: 1 }],
        sections: sections,
        sections_url: window.location.pathname,
      }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        if (data.status) throw new Error(data.description || 'No se pudo agregar');
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.renderContents(data);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          return;
        }
        // PUB_SUB_EVENTS es una const global del tema (no cuelga de window)
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'nailz-upsell', cartData: data });
        }
      })
      .catch(function () {
        button.removeAttribute('aria-disabled');
        button.classList.remove('is-loading');
        button.textContent = 'Reintentar';
      });
  });
})();
